import mapTags, { mapDisplayNameValue } from './mapTags';

const mapTaxonomy = taxonomy => ({
  applicationRoleName: taxonomy.applicationRoleName,
  documentType: mapDisplayNameValue(taxonomy.documentType),
  documentTags: mapTags(taxonomy.documentTags)
});

export default mapTaxonomy;
